// @flow

import React, { type ComponentType } from 'react';

// THIS CAN CRASH SSR!!!!
// Date.now() will differ on server and client

type InjectedProps = { id: number | void };

function withUniqueId<Props: {}>(
  WrappedComponent: ComponentType<Props>,
): ComponentType<$Diff<Props, InjectedProps>> {
  return (props: $Diff<Props, InjectedProps>) => <WrappedComponent {...props} id={Date.now()} />;
}

export default withUniqueId;
